import { p_canImportStock } from "constants/permissions"
import DispatchMapPage from "pages/dispatch/DispatchMapPage"
import DispatchTable from "pages/dispatch/DispatchTable"
import DMSHomePage from "pages/dms"
import CheckSkus from "pages/dms/trip-detail/CkeckSkus"
import ItemDetail from "pages/dms/trip-detail/ItemDetail"
import TripDetail from "pages/dms/trip-detail/TripDetail"
import FundFlowPage from "pages/fund-flow.page"
import FundFlowList from "pages/fund-flow/table/FundFlowList"
import PaymentSettlement from "pages/fund-flow/table/PaymentSettlement"
import TransactionList from "pages/fund-flow/table/TransactionList"
import AddConsolidatedOrder from "pages/order/add/AddConsolidatedOrder"
import AddOrder from "pages/order/add/AddOrder"
import OrderTable from "pages/order/OrderTable"
import OrderView from "pages/order/OrderView"
import SellableItemOrders from "pages/order/SellableItemOrders"

import AddUpdateStock from "pages/stock-management/add-update/AddUpdateStock"
import BatchDetailPage from "pages/stock-management/BatchDetailPage"
import BatchTable from "pages/stock-management/BatchTable"
import ImportStockTransactions from "pages/stock-management/ImportStockTransactions"
import SellableItemStocks from "pages/stock-management/SellableItemStocks"
import StockImportAll from "pages/stock-management/StockImportAll"
import StockTable from "pages/stock-management/StockTable"
import StockSummaryDcTable from "pages/stock-summary/DcTable"
import SellableItemTable from "pages/stock-summary/SellableItemTable"
import ApprovalTable from "pages/stock-take-approval/ApprovalTable"
import DcRequestsTable from "pages/stock-take-approval/DcRequestsTable"
import React from "react"
import { VesaRouteType } from "routes"

const ecommerceRoutes: VesaRouteType[] = [
  {
    icon: "add-row-bottom",
    title: "Stocks",
    path: "stock",
    permission: ["ds_view_stock"],
    element: <SellableItemStocks />,
    children: [
      {
        index: true,
        title: "Stocks",
        element: <StockTable />,
      },
      {
        title: "Batches",
        path: "batches",
        element: <BatchTable />,
      },
    ],
  },
  {
    path: "stock/batches/:id",
    element: <BatchDetailPage />,
  },
  {
    path: "stock/sellable-items",
    element: <AddUpdateStock />,
  },
  {
    path: "stock/import/all",
    element: <StockImportAll />,
    permission: [p_canImportStock],
  },
  {
    path: "stock/import/transactions",
    element: <ImportStockTransactions />,
    permission: [p_canImportStock],
  },
  {
    icon: "th-list",
    title: "Orders",
    element: <OrderView />,
    permission: ["ds_view_order"],
    path: "orders",
    children: [
      {
        index: true,
        title: "All Orders",
        element: <OrderTable />,
      },
      {
        title: "Orders By Sellable Items",
        path: "sellable-items",
        element: <SellableItemOrders />,
      },
    ],
  },
  {
    path: "orders/add/new/*",
    element: <AddOrder />,
  },
  {
    path: "orders/add/new-consolidated/*",
    element: <AddConsolidatedOrder />,
  },
  {
    title: "Dispatches",
    icon: "send-to",
    path: "dispatch",
    element: <DispatchTable />,
    permission: ["ds_view_dispatch"],
  },
  {
    path: "dispatch/:id",
    element: <DispatchMapPage />,
  },
  {
    icon: "truck",
    title: "Loading",
    element: <DMSHomePage />,
    permission: ["ds_view_dms"],
    path: "dms",
  },
  {
    path: "dms/trip/:id",
    element: <TripDetail />,
  },
  {
    path: "dms/trip/:id/item/:itemId",
    element: <ItemDetail />,
  },
  {
    path: "dms/trip/:id/check-skus",
    element: <CheckSkus />,
  },
  {
    title: "Stock take approval",
    icon: "send-to",
    path: "approval-stock-take",
    element: <ApprovalTable />,
    permission: ["ds_view_dispatch"],
  },
  {
    path: "approval-stock-take/:id",
    element: <DcRequestsTable />,
  },
  {
    title: "Stock summary",
    icon: "clipboard",
    path: "summary-stock",
    element: <StockSummaryDcTable />,
    permission: ["ds_view_dispatch"],
  },
  {
    path: "summary-stock/:id",
    element: <SellableItemTable />,
  },
  {
    title: "Fund flow",
    icon: "th-list",
    path: "fund-flow",
    element: <FundFlowPage />,
    permission: ["ds_view_fund_flow"],
    children: [
      {
        index: true,
        title: "List",
        element: <FundFlowList />,
      },
      {
        title: "Transactions",
        path: "transactions",
        element: <TransactionList />,
      },
    ],
  },
  {
    title: "Payment Settlement",
    icon: "clipboard",
    path: "payment-settlement",
    element: <PaymentSettlement />,
    permission: ["ds_view_payment_settlement"],
  },
]

export default ecommerceRoutes
